import {
  Box,
  Divider,
  Grid2,
  LockIcon,
  Tab,
  Tabs,
  Typography,
} from "components";
import { HoldingDataInterface } from "interfaces/Portfolio";
import { PortfolioSummary } from "Pages";
import React from "react";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import PortfolioHoldingDetails from "./PortfolioHoldingsDetails/PortfolioHoldingDetails";

interface Props {
  holdingSummaryDetails: HoldingDataInterface;
}

const PortfolioHoldingViewTab: React.FC<Props> = ({
  holdingSummaryDetails,
}) => {
  const dispatch = useAppDispatch();

  const userData = useAppSelector((state) => state?.user?.userData);
  const { portfolioExtendedViewTabs, portfolioTabs } = useAppSelector(
    (state) => state?.app?.tab,
  );

  const tabLabels = [
    {
      name: "Overview",
      canAccess: true,
    },
    {
      name: "All Holdings",
      canAccess: true,
    },
    {
      name: "Equity",
      canAccess: userData?.grantAccess,
    },
    {
      name: "Mutual Funds",
      canAccess: userData?.grantAccess,
    },
    {
      name: "ETF",
      canAccess: userData?.grantAccess,
    },
    {
      name: "Cash & Cash Equivalents",
      canAccess: userData?.grantAccess,
    },
    {
      name: "Private Equity",
      canAccess: userData?.grantAccess,
    },
    {
      name: "Fixed Deposit",
      canAccess: userData?.grantAccess,
    },
    {
      name: "AIF",
      canAccess: userData?.grantAccess,
    },
    // {
    //   name: "Positions",
    //   canAccess: userData?.grantAccess,
    // },
  ];

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    dispatch(TAB({ tabKey: "portfolioExtendedViewTabs", tabValue: newValue }));
  };

  const renderTabContent = () => {
    if (portfolioTabs !== 0) return null;

    if (portfolioExtendedViewTabs === 0) {
      return <PortfolioSummary />;
    }

    if (portfolioExtendedViewTabs > 0) {
      return (
        <PortfolioHoldingDetails
          portfolioExtendedViewTabs={portfolioExtendedViewTabs}
        />
      );
    }

    return null;
  };

  return (
    <Grid2 container size={12}>
      <Grid2 size={10}>
        <Tabs
          value={portfolioExtendedViewTabs}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons={false}
        >
          {tabLabels.map((label, index) => (
            <Tab
              disabled={!label.canAccess}
              key={index}
              label={
                <Box display={"flex"} gap={1}>
                  <Typography>{label.name}</Typography>
                  {!label.canAccess && <LockIcon width={16} height={16} />}
                </Box>
              }
              disableRipple
            />
          ))}
        </Tabs>
      </Grid2>

      {portfolioExtendedViewTabs === 0 && (
        <Grid2
          size={2}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Typography fontWeight={500} fontSize={12}>
            XIRR:&nbsp;
          </Typography>
          <Typography fontWeight={600} fontSize={18}>
            {holdingSummaryDetails?.xirr
              ? `${holdingSummaryDetails?.xirr.toFixed(2)}%`
              : "-"}
          </Typography>
        </Grid2>
      )}

      <Grid2 size={12} mb={2}>
        <Divider />
      </Grid2>

      <Grid2 size={12}>{renderTabContent()}</Grid2>
    </Grid2>
  );
};

export default PortfolioHoldingViewTab;
